<div class="c-cms-form" sk-field="{{field.fieldName}}">
    <div class="form-flex">
        <div class="form-label">{{if field.required == 1}}<span class="form-required">*</span>{{/if}}{{field.displayName}}</div>
        <div class="form-value">
            <div class="form-row">
                <div class="c-form-select">
                    <div class="select-menu">
                        <div class="select-value" skf-text="$field.value[0] || '请选择'"></div>
                        <div class="select-tips"></div>
                    </div>
                    <div class="select-mask"></div>
                    <ul class="select-main">
                        {{each field.listOptions}}
                        <li skf-options="{{$index}}" skf-class="$value.checked ? 'select-close active' : 'select-close'"
                            skf-click="$parent.clickList({{$value.optionId}}, '{{field.fieldName}}')" >
                            <span class="select-text">
                                {{$value.optionValue}}
                            </span>
                            {{if $value.otherisFillIn == 1}}
                            <input type="text" class="select-other"
                                   skf-options="{{$index}}" skf-value="$value.otherValue"
                                   skf-click="$parent.clickListFocus('{{$value.optionId}}', '{{field.fieldName}}')"
                                   skf-change="$parent.changeListOtherValue({{$value.optionId}}, '{{field.fieldName}}')" />
                            {{/if}}

                            <div class="form-error" skf-options="{{$index}}" skf-if="$value.checked && $value.dirty && $value.otherisFillIn == 1 && $value.otherIsRequire == 1 && !$value.otherValue">请填写</div>

                        </li>
                        {{/each}}
                    </ul>
                </div>
            </div>

            <div class="form-row form-error" skf-if="$field.dirty && $field.invalid" skf-text="$field.validationMessage"></div>

        </div>
    </div>
</div>